module.exports = __webpack_public_path__ + "static/media/dongtu1.18650de1.gif";